import { TransactionDTO } from '../dtos';
import { IS_NOT_NULL_OR_UNDEFINED } from '../../utils';

export const POPULATE_FOR_THIS_ACCOUNT_ATTRIBUTE = (
	transactions: Array<TransactionDTO>,
	accountId: number
): Array<TransactionDTO> => {
	let transactionsCopy = [];
	try {
		if (IS_NOT_NULL_OR_UNDEFINED(transactions) && transactions.length > 0) {
			transactionsCopy = [...transactions];
			transactionsCopy.forEach((transaction) => {
				transaction.forThisAccount = transaction.accountId == accountId;
			});
		}
	} catch (error) {
		console.log('POPULATE_FOR_THIS_ACCOUNT_ATTRIBUTE error: ', error);
	}

	return transactionsCopy;
};
